import domReady from '@wordpress/dom-ready';
import {on} from 'delegated-events';
import './lib/carousel';

/**
 * Initialize zip code lookup on modal and page open - callback
 */
window.initZip = function() {
  const zip = localStorage.getItem('myZip');
  console.log('Loaded Modal!');
  // var prodName = url.substr(url.lastIndexOf('/')+1);
  const path = window.location.pathname;
  // const part = path.split('/').pop();

  console.log(path);
  if (path !== '/event/boxing-davis-vs-cruz/' && path !== '/event/soccer-ecuador-vs-el-salvador/') {
    document.getElementById('ppvcallout').style.display='none';
  };

  if (zip) {
    const form = document.querySelector('.js-zip-form');

    if (form) {
      const input = form.querySelector('.js-zip-field');

      if (input) {
        input.value = zip;
        zipFormSubmit(form);
      }
    }
  }
};

domReady(function() {
  newFlickity(
    '.carousel-list--event',
    {
      contain: true,
      freeScroll: false,
      groupCells: true,
      pageDots: false,
      imagesLoaded: true,
      prevNextButtons: true,
    },
    (el) => {},
    true
  );

  on('submit', '.js-zip-form', zipFormSubmit);
  on('change', '.js-zip-provider', providerChange);
  on('change', '#eventSelect-linker', populateSearchDropdown);
  on('change', '#sportSelect-linker', populateSearchDropdown);
  window.initZip();
});

/**
 * Function to control the zip code form
 *
 * @param {object} obj - the event object or targeted element
 */
function zipFormSubmit(obj) {
  if (obj.currentTarget) obj.preventDefault();

  const form = obj.currentTarget || obj;
  const input = form.querySelector('.js-zip-field');

  if (input && input.value) {
    grabProviders(
      input.value,
      form.dataset.productId,
      form.dataset.productType
    );
  } else {
    zipMessageUpdate('Fill in your Zip Code to see the schedule');
  }
}

/**
 * Function to say hello to the user
 *
 * @param {object} obj - the event object or targeted element
 */
function populateSearchDropdown(obj) {
  if (obj.currentTarget.value) {
    console.log('event.currentTarget.value: '+obj.currentTarget.value);
    window.location.href = obj.currentTarget.value;
  }
}

/**
 * Function to control the provider form
 *
 * @param {object} obj - the event object or targeted element
 */
function providerChange(obj) {
  if (obj.currentTarget) obj.preventDefault();

  const select = obj.currentTarget || obj;
  const form = select.parentNode.parentNode;
  const input = form.querySelector('.js-zip-field');

  localStorage.setItem('myProvider', select.value);

  if (input && input.value) {
    grabSchedule(
      input.value,
      select.value,
      form.dataset.productId,
      form.dataset.productType
    );
  } else {
    zipMessageUpdate('Fill in your Zip Code to see the schedule');
  }
}

/**
 * Function to update (and show) the help message
 *
 * @param {String} message - event
 */
function zipMessageUpdate(message) {
  const el = document.querySelector('.js-zip-message');

  el.textContent = message;

  showZipMessage();
}

/**
 * Function to show the help message, and hide any table rows.
 *
 * @param {HTMLElement} messageEl - the message element
 */
function showZipMessage(messageEl) {
  const el = messageEl ? messageEl : document.querySelector('.js-zip-message');

  el.hidden = false;

  const table = document.querySelector('.js-schedule');
  if (table) {
    const firstRow = table.querySelector('tr');
    table.innerHTML = '';
    table.appendChild(firstRow);
  }
}

/**
 * Function to hide the help message, and show any table rows.
 *
 * @param {Object} data - the schedule data
 */
function showZipSchedule(data) {
  const el = document.querySelector('.js-zip-message');
  el.hidden = true;

  if (data.zipcodechannellineup.length == 0) {
    zipMessageUpdate('No results found. Please try again.');
    return;
  }
  let lineup = data.zipcodechannellineup[0].channellineup;

  // if this is a sport, we need to do something with the months
  if (lineup.length && lineup[0].month) {
    // if (lineup.length > 1) {
    // addMonthList(lineup); // make the months select
    // }
    // lineup = lineup[0].monthchanneldetails; // it will be this when the API is returnng multiple months and we only want the first by default
    let newLineup = [];
    lineup.forEach(function(month) {
      newLineup = newLineup.concat(month.monthchanneldetails);
    });
    lineup = newLineup;
  }

  if (lineup.length == 0) {
    zipMessageUpdate('No results found. Please try again.');
    return;
  }
  const table = document.querySelector('.js-schedule');

  let schedule = '';
  let scheduleDate = false;

  lineup.forEach(function(item) {
    if (!scheduleDate || scheduleDate != item.schedule_date) {
      scheduleDate = item.schedule_date;

      const date = new Date(item.schedule_date);
      schedule += `<td class="schedule__table-heading" colspan="3">${date.toLocaleDateString(
        'en-US',
        {year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'}
      )}</td>`;
    }
    schedule += `<tr><td>${item.title}</td><td>${
      item.schedule_time_Eastern
    }</td><td>${item.channel}</td></tr>`;
  });

  if (table) table.innerHTML = schedule;
}

/**
 * Function to get providers to the product and zip
 *
 * @param {String} zip - zip code entered via the form
 * @param {String} productId - id of the product in the API
 * @param {String} productType - type of the product
 */
function grabProviders(zip, productId, productType) {
  document.documentElement.classList.add('is-loading');

  fetch(
    `https://indemandapi.public.fkvpn.net/${productType}/providers?productId=${productId}&zipcode=${zip}`,
    {
      method: 'GET',
      headers: {
        Authorization: 'Basic ' + btoa('apiuser:gs7jr9fcrgUVqvhjv3zX'),
      },
    }
  )
    .then((response) => response.json())
    .then((json) => {
      handleProviderData(json, zip, productId, productType);
      document.documentElement.classList.remove('is-loading');
    })
    .catch((error) => console.error(error));
}

/**
 * Function to deal with returned provider data
 *
 * @param {Object} data - the returned data
 * @param {String} zip - zip code entered via the form
 * @param {String} productId - id of the product in the API
 * @param {String} productType - type of the product
 */
function handleProviderData(data, zip, productId, productType) {
  const providers = data.msos;

  if (providers.length == 0) {
    removeProviderList();

    zipMessageUpdate(
      'There are no providers for this zip code. Please try again.'
    );
  } else if (providers.length == 1) {
    localStorage.setItem('myZip', zip);

    addProviderList(providers);

    grabSchedule(zip, providers[0].mso_Id, productId, productType);
  } else {
    localStorage.setItem('myZip', zip);

    addProviderList(providers);

    zipMessageUpdate('Choose a provider to see the schedule');
  }
}

/**
 * Function to add the providers list
 *
 * @param {Object} providers - the providers object
 */
function addProviderList(providers) {
  removeProviderList();

  const providerSelectWrap = document.createElement('div');
  providerSelectWrap.classList.add('js-zip-provider-wrap');
  const myProvider = localStorage.getItem('myProvider');
  let localProvider = false;

  let providerSelect = `<select class="js-zip-provider" aria-label="provider"><option value="" disabled hidden${
    providers.length > 1 ? ' selected' : ''
  }>Provider</option>`;
  providers.forEach(function(provider) {
    const selected =
      providers.length == 1 || myProvider == provider.mso_Id ? ' selected' : '';
    if (myProvider == provider.mso_Id) localProvider = true;
    providerSelect += `<option value="${provider.mso_Id}"${selected}>${
      provider.mso_name
    }</option>`;
  });
  providerSelect += '</select>';

  providerSelectWrap.innerHTML = providerSelect;

  const zipForm = document.querySelector('.js-zip-form');
  if (zipForm) zipForm.appendChild(providerSelectWrap);

  if (localProvider && providers.length > 1) {
    providerChange(providerSelectWrap.querySelector('.js-zip-provider'));
  }
}

/**
 * Function to remove the provider list
 */
function removeProviderList() {
  const el = document.querySelector('.js-zip-provider-wrap');

  if (el) el.remove();
}

/**
 * Function to hello world
 */
function thisfunc() {
  console.log('Hello World!');
}


/**
 * Function to get the schedule for the chosen provider
 *
 * @param {String} zip - zip code entered via the form
 * @param {String} providerId - id of the provider in the API
 * @param {String} productId - id of the product in the API
 * @param {String} productType - type of the product
 */
function grabSchedule(zip, providerId, productId, productType) {
  document.documentElement.classList.add('is-loading');

  fetch(
    `https://indemandapi.public.fkvpn.net/${productType}/lineup?productId=${productId}&zipcode=${zip}&msoid=${providerId}`,
    {
      method: 'GET',
      headers: {
        Authorization: 'Basic ' + btoa('apiuser:gs7jr9fcrgUVqvhjv3zX'),
      },
    }
  )
    .then((response) => response.json())
    .then((json) => {
      showZipSchedule(json);
      document.documentElement.classList.remove('is-loading');
    })
    .catch((error) => console.error(error));
}

/**
 * Function to add the month list
 *
 * @param {Array} months - the months array
 */
// function addMonthList(months) {
//   removeMonthList();

//   console.log(months);

//   const monthSelectWrap = document.createElement('div');
//   monthSelectWrap.classList.add('js-zip-month-wrap');

//   let monthSelect = '<select class="js-zip-month" aria-label="month">';
//   months.forEach(function(month) {
//     console.log(month);
//     // monthSelect += `<option value="${provider.mso_Id}">${
//     //   provider.mso_name
//     // }</option>`;
//   });
//   monthSelect += '</select>';
// }

/**
 * Function to remove the provider list
 */
// function removeMonthList() {
//   const el = document.querySelector('.js-zip-month-wrap');

//   if (el) el.remove();
// }

